/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Azure subscription configuration. Applicable if `cloudProvider` is set to `AZURE`. 
*/
export class AzureSourceAccountAttributesInput {
  /**
  * ID of the Azure tenant the source subscription belongs to.
  */
  'tenantId': string;
  /**
  * ID of the Azure source subscription.
  */
  'subscriptionId'?: string;
  /**
  * The application ID
  */
  'applicationId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": ""
    },
    {
      "name": "subscriptionId",
      "baseName": "subscriptionId",
      "type": "string",
      "format": ""
    },
    {
      "name": "applicationId",
      "baseName": "applicationId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureSourceAccountAttributesInput.attributeTypeMap;
  }

  public constructor() {
  }
}

